module.exports = __webpack_public_path__ + "assets/img/router_packagejson.b876d983.jpg";